import { Pipe, PipeTransform } from '@angular/core';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';

@Pipe({
  name: 'garbageCan',
  standalone: false,
})
export class GarbageCanPipe implements PipeTransform {
  transform(string: string): unknown {
    return `${string} <i class="${ZiroIcons.DELETE_SMALL} ps-1 text-dark"><i/>`;
  }
}
